export const REFRESH_ERROR = "redux_store:auto_refresh.error.refresh";



// WEBPACK FOOTER //
// ./src/errors/autoRefresh.js